/* Bhavana Handlooms — Product tabs (sections/bh-product-tabs.liquid). ES5 only.
   Tabs fetch /collections/<handle>?view=bh-cards[-mix]; "Your size" switch; quick "+ Add" sheet. */
(function(){
  'use strict';
  if(window.__bhpt) return;
  window.__bhpt = true;

  var CACHE = {};
  var PENDING = {};
  var LS_KEY = 'bh:size';
  var CAP = 3;
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function arr(list){ return Array.prototype.slice.call(list || []); }
  function closest(el, sel){
    if(el && el.nodeType === 3) el = el.parentElement;
    return el && el.closest ? el.closest(sel) : null;
  }
  function lsGet(){ try { return window.localStorage.getItem(LS_KEY) || ''; } catch(e){ return ''; } }
  function lsSet(v){
    try {
      if(v) window.localStorage.setItem(LS_KEY, v);
      else window.localStorage.removeItem(LS_KEY);
    } catch(e){}
  }
  function norm(s){
    s = String(s || '').toUpperCase().replace(/\s+/g, '');
    var i = s.indexOf('(');
    if(i > 0) s = s.slice(0, i);
    if(s === 'XXL') return '2XL';
    if(s === 'XXXL') return '3XL';
    if(s === 'XXXXL') return '4XL';
    if(s === 'XXXXXL') return '5XL';
    return s;
  }
  function parseMap(str, normalise){
    var m = {};
    String(str || '').split(',').forEach(function(pair){
      var k = pair.split('=');
      if(k.length < 2) return;
      var a = k[0].trim();
      var b = k.slice(1).join('=').trim();
      if(!a || !b) return;
      m[normalise ? norm(a) : a] = b;
    });
    return m;
  }
  function el(tag, cls, text){
    var n = document.createElement(tag);
    if(cls) n.className = cls;
    if(text != null) n.textContent = text;
    return n;
  }
  function idle(fn){
    if(window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 4000 });
    else setTimeout(fn, 2000);
  }
  function postJSON(path, body){
    return fetch(ROOT_URL + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function markQuickAdd(){
    try { postJSON('cart/update.js', { attributes: { 'Quick add': 'Home' } }).catch(function(){}); } catch(e){}
  }

  /* ---------- tabs ---------- */
  function chipData(chip){
    return {
      url: chip.getAttribute('data-url') || '',
      handle: chip.getAttribute('data-handle') || '',
      sort: chip.getAttribute('data-sort') || '',
      sized: chip.getAttribute('data-sized') === 'true',
      mix: chip.getAttribute('data-mix') === 'true',
      addon: chip.getAttribute('data-addon') === 'true',
      label: chip.getAttribute('data-label') || '',
      allLabel: chip.getAttribute('data-all-label') || '',
      allLink: chip.getAttribute('data-all-link') || chip.getAttribute('href') || ''
    };
  }
  function getChips(st){ return arr(st.root.querySelectorAll('.bhpt-chip')); }

  function sizeParams(st, size){
    if(!size) return '';
    var p = '&filter.v.option.size=' + encodeURIComponent(size);
    var al = st.aliases[size] || st.aliases[norm(size)];
    if(al && al !== size) p += '&filter.v.option.size=' + encodeURIComponent(al);
    return p;
  }
  function addParams(href, params){
    if(!params) return href;
    var hash = '';
    var h = href.indexOf('#');
    if(h > -1){ hash = href.slice(h); href = href.slice(0, h); }
    return href + (href.indexOf('?') > -1 ? '&' : '?') + params.replace(/^&/, '') + hash;
  }
  function fetchUrl(st, c, size){
    return c.url + '?view=' + (c.mix ? 'bh-cards-mix' : 'bh-cards') + '&filter.v.availability=1' +
      (c.sort && c.sort !== 'default' ? '&sort_by=' + encodeURIComponent(c.sort) : '') + sizeParams(st, size);
  }
  function cacheKey(c, size){ return c.handle + '|' + c.sort + '|' + size + '|' + (c.mix ? 1 : 0); }

  function getText(url, key){
    if(CACHE[key] != null) return Promise.resolve(CACHE[key]);
    if(PENDING[key]) return PENDING[key];
    var p = fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } }).then(function(res){
      if(!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    }).then(function(t){
      if(t.indexOf('data-bh-cards') === -1) throw new Error('Unexpected page');
      CACHE[key] = t;
      delete PENDING[key];
      return t;
    }).catch(function(err){
      delete PENDING[key];
      throw err;
    });
    PENDING[key] = p;
    return p;
  }

  function radioFor(st, v){
    if(!v) return null;
    var list = arr(st.root.querySelectorAll('.bhpt-r'));
    for(var i = 0; i < list.length; i++){
      if(list[i].value && (list[i].value === v || norm(list[i].value) === norm(v))) return list[i];
    }
    return null;
  }
  function markSaved(st, v){
    arr(st.root.querySelectorAll('.bhpt-sz label.is-saved')).forEach(function(l){ l.classList.remove('is-saved'); });
    var r = radioFor(st, v);
    if(r && r.nextElementSibling) r.nextElementSibling.classList.add('is-saved');
  }
  function savedSize(st){
    if(!st.remember) return '';
    var v = lsGet();
    var r = radioFor(st, v);
    return r ? r.value : '';
  }
  function setStatus(st, txt){ if(st.status) st.status.textContent = txt; }

  function drawFew(st, scope){
    arr(scope.querySelectorAll('[data-bhpt-cell][data-stock]')).forEach(function(cell){
      var ov = cell.querySelector('.bhpt-ov');
      if(!ov) return;
      var pill = ov.querySelector('.bhpt-few');
      var n = parseInt(cell.getAttribute('data-stock'), 10) || 0;
      var want = st.few > 0 && n > 0 && n <= st.few;
      if(want && !pill){
        ov.insertBefore(el('span', 'bhpt-few', 'Only ' + n + ' left'), ov.firstChild);
      } else if(!want && pill){
        pill.parentNode.removeChild(pill);
      }
    });
  }
  function squareify(cell){
    arr(cell.querySelectorAll('.media--portrait')).forEach(function(m){
      m.classList.remove('media--portrait');
      m.classList.add('media--square');
    });
  }
  function clearCells(st){
    arr(st.rail.children).forEach(function(n){
      if(n.hasAttribute('data-bhpt-fixed') || n.hasAttribute('data-bhpt-fixed-end')) return;
      st.rail.removeChild(n);
    });
  }
  function insertCells(st, frag){
    var end = st.rail.querySelector('[data-bhpt-fixed-end]');
    if(end) st.rail.insertBefore(frag, end);
    else st.rail.appendChild(frag);
  }
  // size-chip links from a filtered collection come out as ?variant=1?variant=2 — keep them valid
  function fixHrefs(scope){
    arr(scope.querySelectorAll('a.size-chip[href]')).forEach(function(a){
      var h = a.getAttribute('href') || '';
      var i = h.indexOf('?');
      if(i > -1 && h.indexOf('?', i + 1) > -1) a.setAttribute('href', h.slice(0, i + 1) + h.slice(i + 1).replace(/\?/g, '&'));
    });
  }
  // hearts on fetched cards: show the saved state (theme.js only syncs at load / on a click)
  function syncHearts(scope){
    var list;
    try { list = JSON.parse(window.localStorage.getItem('bh:wishlist') || '[]'); } catch(e){ list = []; }
    if(!list || !list.length) list = [];
    arr(scope.querySelectorAll('[data-wishlist-toggle]')).forEach(function(b){
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      var title = b.getAttribute('data-title') || 'item';
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + title + (on ? ' from wishlist' : ' to wishlist'));
    });
  }
  function skeleton(st){
    var rail = st.rail;
    rail.style.minHeight = rail.offsetHeight + 'px';
    clearCells(st);
    var frag = document.createDocumentFragment();
    for(var i = 0; i < st.n; i++){
      var d = el('div', 'bhpt-cell bhpt-skel');
      d.setAttribute('aria-hidden', 'true');
      d.innerHTML = '<div class="card card--skeleton"><div class="media"></div><div class="line"></div><div class="line line--short"></div></div>';
      frag.appendChild(d);
    }
    insertCells(st, frag);
    rail.setAttribute('aria-busy', 'true');
  }

  function updateLinks(st, c, size){
    var href = addParams(c.allLink, sizeParams(st, size));
    var extra = size ? ' in ' + size : '';
    if(st.seeall){
      st.seeall.setAttribute('href', href);
      var t = st.seeall.querySelector('.bhpt-seeall__t');
      if(t) t.textContent = (c.allLabel || ('See all ' + c.label)) + extra;
    }
    if(st.viewall){
      st.viewall.setAttribute('href', href);
      var v = st.viewall.querySelector('.bhpt-viewall__t');
      if(v) v.textContent = (c.allLabel || ('See all ' + c.label)) + extra;
    }
    if(st.headAll) st.headAll.setAttribute('href', href);
  }
  function sizesRow(st, c){ if(st.sizesBox) st.sizesBox.hidden = !c.sized; }

  function showEmpty(st, c, size, on){
    var box = st.empty;
    if(!box) return;
    box.innerHTML = '';
    if(!on){ box.hidden = true; return; }
    box.appendChild(el('p', 'bhpt-empty__msg', size ? 'No ' + c.label + ' in ' + size + ' right now.' : 'Nothing here right now.'));
    var acts = el('div', 'bhpt-empty__acts');
    if(size){
      var b = el('button', 'btn btn--ghost', 'See all sizes');
      b.type = 'button';
      b.setAttribute('data-bhpt-allsizes', '');
      acts.appendChild(b);
    } else {
      var a = el('a', 'btn btn--ghost', c.allLabel || ('See all ' + c.label));
      a.href = c.allLink;
      acts.appendChild(a);
    }
    var wa = el('a', '', 'Ask us on WhatsApp ›');
    wa.href = 'https://wa.me/' + st.wa + '?text=' + encodeURIComponent(size ? 'Hi, do you have ' + c.label + ' in ' + size + '?' : 'Hi, do you have ' + c.label + ' in stock?');
    wa.target = '_blank';
    wa.rel = 'noopener';
    acts.appendChild(wa);
    box.appendChild(acts);
    box.hidden = false;
  }

  function render(st, c, text, size){
    var tpl = document.createElement('template');
    tpl.innerHTML = text;
    var box = tpl.content.querySelector('[data-bh-cards]');
    var cells = box ? arr(box.querySelectorAll('[data-bhpt-cell]')) : [];
    var keep = [];
    var last = null;
    var seen = {};
    for(var i = 0; i < cells.length && keep.length < st.n; i++){
      var cell = cells[i];
      if(!size && st.min > 0 && cell.getAttribute('data-sized') === 'true' && (parseInt(cell.getAttribute('data-sz'), 10) || 0) < st.min) continue;
      var t = cell.getAttribute('data-title');
      if(t !== null && t === last) continue;
      if(c.mix){
        var v = cell.getAttribute('data-vendor') || '';
        if((seen[v] || 0) >= CAP) continue;
        seen[v] = (seen[v] || 0) + 1;
      }
      if(st.square) squareify(cell);
      keep.push(cell);
      last = t;
    }
    var frag = document.createDocumentFragment();
    keep.forEach(function(n){ frag.appendChild(document.importNode(n, true)); });
    clearCells(st);
    insertCells(st, frag);
    drawFew(st, st.rail);
    fixHrefs(st.rail);
    syncHearts(st.rail);
    st.rail.style.minHeight = '';
    st.rail.removeAttribute('aria-busy');
    st.rail.scrollLeft = 0;
    showEmpty(st, c, size, keep.length === 0);
    var txt = c.sized ? (size ? 'Showing ' + size : 'Showing all sizes') : 'Showing ' + c.label;
    var count = box ? box.getAttribute('data-count') : '';
    if(st.showCount && count) txt += ' · ' + count + ' styles';
    setStatus(st, txt);
    updateArrows(st);
  }

  function load(st){
    var chip = st.chip;
    if(!chip) return;
    var c = chipData(chip);
    var size = c.sized ? st.size : '';
    var key = cacheKey(c, size);
    var my = ++st.req;
    sizesRow(st, c);
    updateLinks(st, c, size);
    if(CACHE[key] != null){ render(st, c, CACHE[key], size); return; }
    skeleton(st);
    getText(fetchUrl(st, c, size), key).then(function(t){
      if(my === st.req) render(st, c, t, size);
    }).catch(function(){
      if(my === st.req) window.location.href = addParams(chip.getAttribute('href'), sizeParams(st, size));
    });
  }

  function activate(st, chip){
    if(!chip || chip === st.chip) return;
    getChips(st).forEach(function(ch){
      var on = ch === chip;
      ch.setAttribute('aria-selected', on ? 'true' : 'false');
      ch.setAttribute('tabindex', on ? '0' : '-1');
    });
    st.chip = chip;
    if(st.rail) st.rail.setAttribute('aria-labelledby', chip.id);
    var c = chipData(chip);
    if(c.sized && st.sizesBox && !st.size){
      var saved = savedSize(st);
      if(saved){
        var r = radioFor(st, saved);
        if(r){ r.checked = true; st.size = r.value; }
      }
    }
    load(st);
  }

  function chooseAll(st){
    var r = st.root.querySelector('.bhpt-r[value=""]');
    if(r) r.checked = true;
    st.size = '';
    if(st.remember){ lsSet(''); markSaved(st, ''); }
    load(st);
    if(r) r.focus();
  }

  function scrollRail(st, dir){
    var r = st.rail;
    var d = r.clientWidth * dir;
    if(r.scrollBy){
      try { r.scrollBy({ left: d, behavior: 'smooth' }); return; } catch(e){}
    }
    r.scrollLeft += d;
  }
  function updateArrows(st){
    if(!st.prev || !st.next || !st.rail) return;
    var r = st.rail;
    var max = r.scrollWidth - r.clientWidth;
    st.prev.disabled = r.scrollLeft <= 2;
    st.next.disabled = r.scrollLeft >= max - 2;
    var m = r.querySelector('[data-bhpt-cell] .media, .bhpt-skel .media');
    if(m && st.wrap && m.offsetHeight){
      var top = m.getBoundingClientRect().top - st.wrap.getBoundingClientRect().top + m.offsetHeight / 2;
      if(top > 0) st.wrap.style.setProperty('--bhpt-at', Math.round(top) + 'px');
    }
  }

  function prefetch(st){
    var chips = getChips(st);
    if(chips.length < 2) return;
    var conn = navigator.connection;
    if(conn && (conn.saveData || /2g$/.test(conn.effectiveType || ''))) return;
    var next = null;
    for(var i = 0; i < chips.length; i++){ if(chips[i] !== st.chip){ next = chips[i]; break; } }
    if(!next) return;
    var c = chipData(next);
    var size = c.sized ? (st.size || savedSize(st)) : '';
    getText(fetchUrl(st, c, size), cacheKey(c, size)).catch(function(){});
  }

  function init(root){
    if(!root || root.getAttribute('data-bhpt-ready')) return;
    root.setAttribute('data-bhpt-ready', '1');
    var st = {
      root: root,
      sid: root.getAttribute('data-sid') || '',
      min: parseInt(root.getAttribute('data-min'), 10) || 0,
      n: parseInt(root.getAttribute('data-n'), 10) || 10,
      aliases: parseMap(root.getAttribute('data-aliases'), false),
      remember: root.hasAttribute('data-remember'),
      showCount: root.getAttribute('data-count') === 'true',
      few: parseInt(root.getAttribute('data-few'), 10) || 0,
      chest: parseMap(root.getAttribute('data-chest'), true),
      wa: (root.getAttribute('data-wa') || '918341644907').replace(/[^0-9]/g, ''),
      square: root.classList.contains('bhpt--square'),
      rail: root.querySelector('[data-bhpt-rail]'),
      wrap: root.querySelector('[data-bhpt-wrap]'),
      sizesBox: root.querySelector('[data-bhpt-sizes]'),
      status: root.querySelector('[data-bhpt-status]'),
      empty: root.querySelector('[data-bhpt-empty]'),
      seeall: root.querySelector('.bhpt-seeall'),
      viewall: root.querySelector('[data-bhpt-viewall]'),
      headAll: root.querySelector('[data-bhpt-headall]'),
      prev: root.querySelector('.bhpt-prev'),
      next: root.querySelector('.bhpt-next'),
      chip: root.querySelector('.bhpt-chip[aria-selected="true"]'),
      size: '',
      req: 0,
      timer: null
    };
    root.__bhpt = st;
    if(!st.rail) return;

    // saved size from last visit: gold dot + hint; tab 1 is NOT refetched
    var saved = savedSize(st);
    if(saved && st.sizesBox){
      markSaved(st, saved);
      if(st.chip && chipData(st.chip).sized){
        setStatus(st, 'Last time you chose ' + saved + ' · tap ' + saved + ' to see only your size');
      }
    }
    drawFew(st, st.rail);
    fixHrefs(st.rail);

    // intro button that opens a sheet: hide it when that sheet isn't on the page
    arr(root.querySelectorAll('.bhpt-intro [data-modal-open]')).forEach(function(b){
      if(!document.getElementById(b.getAttribute('data-modal-open'))) b.hidden = true;
    });

    root.addEventListener('click', function(e){
      var chip = closest(e.target, '.bhpt-chip');
      if(chip){
        if(e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || (e.button && e.button !== 0)) return;
        e.preventDefault();
        activate(st, chip);
        return;
      }
      var nav = closest(e.target, '.bhpt-arrow');
      if(nav){ scrollRail(st, nav.classList.contains('bhpt-prev') ? -1 : 1); return; }
      if(closest(e.target, '[data-bhpt-allsizes]')) chooseAll(st);
    });

    root.addEventListener('keydown', function(e){
      var chip = closest(e.target, '.bhpt-chip');
      if(!chip) return;
      var k = e.key || '';
      if(k === 'Enter' || k === ' ' || k === 'Spacebar'){
        e.preventDefault();
        activate(st, chip);
        return;
      }
      var chips = getChips(st);
      var i = chips.indexOf(chip);
      var j = -1;
      if(k === 'ArrowRight' || k === 'Right') j = (i + 1) % chips.length;
      else if(k === 'ArrowLeft' || k === 'Left') j = (i - 1 + chips.length) % chips.length;
      else if(k === 'Home') j = 0;
      else if(k === 'End') j = chips.length - 1;
      if(j < 0) return;
      e.preventDefault();
      chips[j].focus();
      activate(st, chips[j]);
    });

    root.addEventListener('change', function(e){
      var r = e.target;
      if(!r || !r.classList || !r.classList.contains('bhpt-r')) return;
      clearTimeout(st.timer);
      st.timer = setTimeout(function(){
        var on = st.root.querySelector('.bhpt-r:checked');
        var v = on ? on.value : '';
        if(v === st.size) return;
        st.size = v;
        if(st.remember){ lsSet(v); markSaved(st, v); }
        load(st);
      }, 300);
    });

    var ticking = false;
    function onScroll(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(function(){ ticking = false; updateArrows(st); });
    }
    st.rail.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateArrows(st);
    window.addEventListener('load', function(){ updateArrows(st); });

    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){ io.disconnect(); idle(function(){ prefetch(st); }); }
        });
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else {
      idle(function(){ prefetch(st); });
    }

    var sheet = document.getElementById(root.getAttribute('data-sheet') || '');
    if(sheet) bindSheet(sheet);
  }

  /* ---------- quick-add sheet ---------- */
  function q(sheet, sel){ return sheet.querySelector(sel); }

  function setBtn(sheet, text, disabled){
    var b = q(sheet, '.bhq-add');
    if(!b) return;
    b.disabled = !!disabled;
    var sp = b.querySelector('span');
    if(sp) sp.textContent = text;
    var buy = q(sheet, '[data-bhq-buy]');
    if(buy) buy.disabled = !!disabled;
  }
  function refreshBtn(sheet){
    var S = sheet.__bhq;
    if(!S) return;
    var idIn = q(sheet, '[data-bhq-form] [name="id"]');
    if(S.single){
      setBtn(sheet, S.soldOut ? 'Sold out' : 'Add to bag', S.soldOut);
      return;
    }
    var on = q(sheet, '.bhq-r:checked');
    if(on && idIn && idIn.value){
      var s = on.getAttribute('data-s') || '';
      setBtn(sheet, 'Add to bag' + (s ? ' · ' + s : ''), false);
    } else {
      setBtn(sheet, S.sized ? 'Choose a size' : 'Choose an option', true);
    }
  }
  function pickVariant(sheet, inp){
    var idIn = q(sheet, '[data-bhq-form] [name="id"]');
    if(idIn) idIn.value = inp.value;
    var p = inp.getAttribute('data-p');
    var price = q(sheet, '[data-bhq-price]');
    if(p && price) price.textContent = p;
    refreshBtn(sheet);
  }

  function fillSheet(st, sheet, data, pre){
    var mat = sheet.getAttribute('data-mat') === 'true';
    var vs = data.v || [];
    var sized = !!data.sized;
    var single = !!data.single || vs.length === 1;
    var chip = st.chip ? chipData(st.chip) : null;
    var S = {
      st: st,
      data: data,
      sized: sized,
      single: single,
      soldOut: single && !(vs[0] && vs[0].a),
      addon: !!(chip && chip.addon && data.addon),
      done: false,
      size: ''
    };
    sheet.__bhq = S;
    var addBtn = q(sheet, '.bhq-add');
    if(addBtn) addBtn.classList.remove('is-added');
    arr(sheet.querySelectorAll('.bhq-addon__btn[data-bhq-added]')).forEach(function(b){
      b.removeAttribute('data-bhq-added');
      b.disabled = false;
      var sp = b.querySelector('span');
      if(sp) sp.textContent = '+ Add';
      if(b.__bhqLabel) b.setAttribute('aria-label', b.__bhqLabel);
    });

    q(sheet, '[data-bhq-stage]').hidden = false;
    q(sheet, '[data-bhq-done]').hidden = true;
    var heading = q(sheet, '[data-bhq-heading]');
    var img = q(sheet, '[data-bhq-img]');
    if(img){ if(data.img) img.src = data.img; img.alt = ''; }
    q(sheet, '[data-bhq-title]').textContent = data.t || '';
    q(sheet, '[data-bhq-price]').textContent = data.pr || '';

    var fs = q(sheet, '[data-bhq-sizes]');
    var grid = q(sheet, '[data-bhq-grid]');
    var idIn = q(sheet, '[data-bhq-form] [name="id"]');
    grid.innerHTML = '';
    idIn.value = '';
    var anyChest = false;

    if(single){
      fs.hidden = true;
      idIn.value = vs[0] ? String(vs[0].id) : '';
      if(heading) heading.textContent = 'Add to bag';
    } else {
      fs.hidden = false;
      if(heading) heading.textContent = sized ? 'Choose your size' : 'Choose an option';
      var preInput = null;
      vs.forEach(function(v, i){
        var wrap = el('div', 'bhq-sz');
        var inp = document.createElement('input');
        inp.type = 'radio';
        inp.className = 'bhq-r';
        inp.name = 'bhq-size-' + st.sid;
        inp.id = 'BhqSz-' + st.sid + '-' + i;
        inp.value = String(v.id);
        inp.setAttribute('data-s', v.s || '');
        if(data.pv && v.p) inp.setAttribute('data-p', v.p);
        if(!v.a) inp.disabled = true;
        var l = document.createElement('label');
        l.setAttribute('for', inp.id);
        l.appendChild(el('b', '', v.s || ''));
        var ch = sized ? st.chest[norm(v.s)] : '';
        if(ch){ l.appendChild(el('small', '', ch + '″')); anyChest = true; }
        if(!v.a) l.appendChild(el('span', 'visually-hidden', ', sold out'));
        else if(v.q && v.q <= 3) l.appendChild(el('em', '', 'Only ' + v.q + ' left'));
        wrap.appendChild(inp);
        wrap.appendChild(l);
        grid.appendChild(wrap);
        if(pre && v.a && !preInput && norm(v.s) === norm(pre)) preInput = inp;
      });
      if(preInput){ preInput.checked = true; idIn.value = preInput.value; }
    }
    refreshBtn(sheet);
    if(!single){
      var picked = q(sheet, '.bhq-r:checked');
      if(picked) pickVariant(sheet, picked);
    }

    // size chart line
    var line = q(sheet, '[data-bhq-chartline]');
    var chart = q(sheet, '[data-bhq-chart]');
    var chest = q(sheet, '[data-bhq-chest]');
    if(line){
      var hasChart = !!(sized && data.chart);
      chart.hidden = !hasChart;
      if(hasChart) chart.setAttribute('href', data.chart);
      var showChest = sized && !single && anyChest;
      chest.hidden = !showChest;
      var dot = chest.querySelector('.bhq-dot');
      if(dot) dot.hidden = !hasChart;
      line.hidden = !(hasChart || showChest);
    }
    var matEl = q(sheet, '[data-bhq-mat]');
    if(matEl) matEl.hidden = !mat;
    arr(sheet.querySelectorAll('[data-bhq-pdp]')).forEach(function(a){ a.setAttribute('href', data.u || '#'); });
    var wa = q(sheet, '[data-bhq-wa]');
    if(wa){
      var txt = (sized ? 'Hi, please help me choose a size for ' : 'Hi, I have a question about ') + (data.t || '') + ' ' + window.location.origin + (data.u || '');
      wa.setAttribute('href', 'https://wa.me/' + st.wa + '?text=' + encodeURIComponent(txt));
      if(wa.firstChild && wa.firstChild.nodeType === 3) wa.firstChild.nodeValue = sized ? 'Not sure of your size? Ask on WhatsApp' : 'Questions? Ask on WhatsApp';
    }
  }

  function showDone(sheet){
    var S = sheet.__bhq;
    if(!S || S.done) return;
    S.done = true;
    q(sheet, '[data-bhq-stage]').hidden = true;
    q(sheet, '[data-bhq-done]').hidden = false;
    var heading = q(sheet, '[data-bhq-heading]');
    if(heading) heading.textContent = 'Added to bag';
    var ok = q(sheet, '[data-bhq-ok]');
    var on = q(sheet, '.bhq-r:checked');
    var sz = on ? (on.getAttribute('data-s') || '') : '';
    if(ok) ok.textContent = '✓ ' + (S.data.t || 'Added to bag') + (sz ? ' · ' + sz : '');
    var box = q(sheet, '[data-bhq-addons]');
    if(box){
      var max = parseInt(sheet.getAttribute('data-addon-n'), 10) || 0;
      var shown = 0;
      arr(box.querySelectorAll('.bhq-addon')).forEach(function(li){
        var ok2 = S.addon && shown < max && li.getAttribute('data-handle') !== S.data.h;
        li.hidden = !ok2;
        if(ok2) shown++;
      });
      box.hidden = shown === 0;
    }
    if(ok) ok.focus({ preventScroll: true });
    markQuickAdd();
  }

  function bindSheet(sheet){
    if(sheet.__bhqBound) return;
    sheet.__bhqBound = true;
    var btn = q(sheet, '.bhq-add');
    if(btn && window.MutationObserver){
      new MutationObserver(function(){
        var S = sheet.__bhq;
        if(btn.classList.contains('is-added')){ if(S) S.busy = false; showDone(sheet); }
        else if(!S || !S.busy) refreshBtn(sheet);
      }).observe(btn, { attributes: true, attributeFilter: ['class'] });
    }
    // "Goes well with": once added, the row keeps "✓ Added" (no second tap by mistake)
    if(window.MutationObserver){
      arr(sheet.querySelectorAll('.bhq-addon__btn')).forEach(function(b){
        b.__bhqLabel = b.getAttribute('aria-label') || '';
        new MutationObserver(function(){
          if(b.classList.contains('is-added')) b.setAttribute('data-bhq-added', '');
          if(!b.hasAttribute('data-bhq-added')) return;
          b.disabled = true;
          var sp = b.querySelector('span');
          if(sp) sp.textContent = '✓ Added';
          b.setAttribute('aria-label', 'Added to bag');
        }).observe(b, { attributes: true, attributeFilter: ['class'] });
      });
    }
  }

  // "+ Add" or the card's size-chip row → fill the sheet; the theme's own [data-modal-open] handler opens it
  document.addEventListener('click', function(e){
    var t = e.target;
    var add = closest(t, '[data-bhpt-add]');
    var row = add ? null : closest(t, '.bhpt-cell .card-sizes');
    if(!add && !row) return;
    var cell = closest(add || row, '[data-bhpt-cell]');
    var root = cell ? closest(cell, '[data-bhpt]') : null;
    if(!root) return;
    if(!root.__bhpt) init(root);
    var st = root.__bhpt;
    var sheet = document.getElementById(root.getAttribute('data-sheet') || '');
    var js = cell.querySelector('[data-bhpt-json]');
    if(!st || !sheet || !js) return;
    var data;
    try { data = JSON.parse(js.textContent); } catch(err){ return; }
    var sizeChip = row ? closest(t, '.size-chip') : null;
    if(row && !sizeChip){
      var addEl = cell.querySelector('[data-bhpt-add]');
      if(addEl){ e.preventDefault(); e.stopPropagation(); addEl.click(); return; }
    }
    var pre = sizeChip ? (sizeChip.textContent || '').trim() : '';
    bindSheet(sheet);
    fillSheet(st, sheet, data, pre);
    var opener = add || sizeChip || row;
    if(sizeChip) e.preventDefault();
    opener.setAttribute('data-modal-open', sheet.id);
    opener.setAttribute('aria-haspopup', 'dialog');
  }, true);

  // sheet size choice
  document.addEventListener('change', function(e){
    var inp = e.target;
    if(!inp || !inp.classList || !inp.classList.contains('bhq-r')) return;
    var sheet = closest(inp, '[data-bhq]');
    if(sheet) pickVariant(sheet, inp);
  });

  // never post an empty variant id
  document.addEventListener('submit', function(e){
    var form = closest(e.target, '[data-bhq-form]');
    if(!form) return;
    var idIn = form.querySelector('[name="id"]');
    if(!idIn || !idIn.value){
      e.preventDefault();
      e.stopPropagation();
      var sheet = closest(form, '[data-bhq]');
      var first = sheet ? sheet.querySelector('.bhq-r:not(:disabled)') : null;
      if(first) first.focus();
      return;
    }
    var sh = closest(form, '[data-bhq]');
    if(sh && sh.__bhq) sh.__bhq.busy = true;
  }, true);

  // optional "Buy now"
  document.addEventListener('click', function(e){
    var buy = closest(e.target, '[data-bhq-buy]');
    if(!buy) return;
    var form = closest(buy, '[data-bhq-form]');
    var idIn = form ? form.querySelector('[name="id"]') : null;
    var id = idIn ? parseInt(idIn.value, 10) : 0;
    if(!id) return;
    buy.disabled = true;
    postJSON('cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(function(res){
      if(!res.ok) throw new Error('add');
      return postJSON('cart/update.js', { attributes: { 'Quick add': 'Home' } }).catch(function(){});
    }).then(function(){
      window.location.href = ROOT_URL + 'checkout';
    }).catch(function(){
      buy.disabled = false;
      window.location.href = ROOT_URL + 'cart';
    });
  });

  /* ---- Back button: come back to the same place (owner, 16 Oct 2026) ----
     Phones often RELOAD the homepage on Back (Instagram / Facebook / WhatsApp browsers,
     low memory) and then show the top of the page with the first tab. When a link is
     tapped we remember the scroll position, the tapped link, its swipe-row position and
     each section's tab + size; on a Back/Forward visit we put them back. */
  var POS_KEY = 'bh:home-pos:' + location.pathname;
  var posDone = false;
  function navType(){
    try {
      var n = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      if(n && n.type) return n.type;
      if(window.performance && performance.navigation) return performance.navigation.type === 2 ? 'back_forward' : 'other';
    } catch(e){}
    return '';
  }
  function pageY(){ return window.pageYOffset || document.documentElement.scrollTop || 0; }
  function scrollerOf(node){
    var p = node ? node.parentElement : null;
    while(p && p !== document.body){
      if(p.scrollWidth > p.clientWidth + 2){
        var ox = window.getComputedStyle(p).overflowX;
        if(ox === 'auto' || ox === 'scroll') return p;
      }
      p = p.parentElement;
    }
    return null;
  }
  function sameLinks(href){
    return arr(document.querySelectorAll('a[href]')).filter(function(a){ return a.getAttribute('href') === href; });
  }
  function readPos(){ try { return JSON.parse(window.sessionStorage.getItem(POS_KEY) || 'null'); } catch(e){ return null; } }
  function savePos(link){
    try {
      var old = readPos() || {};
      var o = { y: pageY(), t: new Date().getTime(), tabs: {} };
      arr(document.querySelectorAll('[data-bhpt]')).forEach(function(root, i){
        var st = root.__bhpt;
        if(!st || !st.chip) return;
        o.tabs[st.sid || ('s' + i)] = { chip: getChips(st).indexOf(st.chip), size: st.size || '' };
      });
      if(link){
        var href = link.getAttribute('href');
        o.href = href;
        o.top = link.getBoundingClientRect().top;
        o.k = sameLinks(href).indexOf(link);
        var sc = scrollerOf(link);
        o.sl = sc ? sc.scrollLeft : 0;
      } else if(old.href && o.t - (old.t || 0) < 5000){
        o.href = old.href; o.top = old.top; o.k = old.k; o.sl = old.sl; o.y = old.y;
      }
      window.sessionStorage.setItem(POS_KEY, JSON.stringify(o));
    } catch(e){}
  }
  document.addEventListener('click', function(e){
    if(e.defaultPrevented || e.button || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    var a = closest(e.target, 'a[href]');
    if(!a || (a.target && a.target !== '_self') || a.host !== location.host) return;
    savePos(a);
  });
  window.addEventListener('pagehide', function(){ savePos(null); });
  function restorePos(){
    if(posDone) return;
    posDone = true;
    var o = readPos();
    if(!o || navType() !== 'back_forward' || new Date().getTime() - (o.t || 0) > 3600000) return;
    try { if('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual'; } catch(e){}
    var moved = false;
    function stop(){ moved = true; }
    ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function(ev){
      window.addEventListener(ev, stop, { passive: true, once: true });
    });
    // tabs and sizes first (their cards load in the background)
    arr(document.querySelectorAll('[data-bhpt]')).forEach(function(root, i){
      var st = root.__bhpt;
      var t = st && o.tabs ? o.tabs[st.sid || ('s' + i)] : null;
      if(!st || !t) return;
      var chip = getChips(st)[t.chip];
      if(t.size && st.sizesBox){
        var r = radioFor(st, t.size);
        if(r){ r.checked = true; st.size = r.value; }
      }
      if(chip && chip !== st.chip) activate(st, chip);
      else if(t.size && st.size) load(st);
    });
    function place(){
      if(moved) return;
      var y = o.y;
      if(o.href){
        var list = sameLinks(o.href).filter(function(a){ return a.offsetParent !== null; });
        var a = list[o.k] || list[0];
        if(a){
          var sc = scrollerOf(a);
          if(sc && o.sl) sc.scrollLeft = o.sl;
          y = a.getBoundingClientRect().top + pageY() - (o.top || 0);
        }
      }
      window.scrollTo(0, Math.max(0, Math.round(y)));
    }
    place();
    var tries = 0;
    var iv = window.setInterval(function(){
      tries++;
      place();
      if(tries >= 12 || moved) window.clearInterval(iv);
    }, 250);
    window.addEventListener('load', function(){ window.setTimeout(place, 60); });
  }

  function boot(){ arr(document.querySelectorAll('[data-bhpt]')).forEach(init); restorePos(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function(e){
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-bhpt]') : null;
    if(r) init(r);
  });
})();
